/**
 * InboxPersonSearchResults — Alvo A round2 (mockup 01/2a): buscar um NOME na
 * Inbox responde com a PESSOA, não com cards de conversa paginados.
 *
 * Seção «Pessoas · N» acima dos resultados de conversa. O card em si vive em
 * `features/persons/PersonHitCard` desde a frente do Localizador Universal
 * (⌘K) — D5: o mesmo componente serve a Inbox e o painel direito da paleta,
 * então uma correção conserta os dois.
 *
 * Fetch GATED: cap `person-read` + termo com 2+ chars (regra «gatear o
 * fetch») + debounce de 300ms por tecla (F.5 M1) com keepPreviousData (sem
 * flicker entre teclas). Sem cap ou sem match: renderiza null — Inbox
 * idêntica à histórica.
 */
import { useEffect, useState } from 'react';

import { useCapability } from '../../hooks/use-capability';
import { PersonHitCard } from '../persons/PersonHitCard';
import { usePersons } from '../persons/use-persons';

const SEARCH_MIN_CHARS = 2;
const PERSONS_LIMIT = 3;

const DEBOUNCE_MS = 300;

export function InboxPersonSearchResults({ search }: { search: string }): JSX.Element | null {
  const canViewPerson = useCapability('person-read');
  const term = search.trim();
  // F.5 M1 — 1 request por PAUSA de digitação, não por tecla.
  const [debouncedTerm, setDebouncedTerm] = useState(term);
  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedTerm(term);
    }, DEBOUNCE_MS);
    return () => {
      clearTimeout(t);
    };
  }, [term]);
  const enabled = canViewPerson && debouncedTerm.length >= SEARCH_MIN_CHARS;
  const { data } = usePersons({ q: debouncedTerm, limit: PERSONS_LIMIT }, enabled, {
    keepPreviousData: true,
  });

  if (!enabled) return null;
  const persons = data?.data ?? [];
  if (persons.length === 0) return null;

  return (
    <div className="inbox-person-hits" data-testid="inbox-person-hits">
      <div className="inbox-person-hits__head">
        Pessoas · {persons.length} encontrada{persons.length === 1 ? '' : 's'}
      </div>
      {persons.map((p) => (
        <PersonHitCard key={p.id} person={p} />
      ))}
    </div>
  );
}
